import React, { useState } from 'react';
import Form from '../../../../adminpanel/components/commonComponents/Form.v2';
import ModalComponent from "../../../../adminpanel/components/commonComponents/ModalComponent";
import DataTableComponent from '../../commonComponents/DataTableComponent';

const modalConfig1 = {
    "confirmationModal": {
        "id": "confirmationModal", "form_id": "confirmationForm", "form_name": "confirmationForm", "body": null, "display": true, buttonType: "submit"
    },
}
let formArray = {
    "confirmationForm": {
        "message": {
            "name": "message", "type": "text", "text_value": "Yes", "disabled": true
        }
    }
}
let modalConfig = {}

const DisplayConnectionTable = ({ tableData, setTableData, updateRecord }) => {

    const [modalFormValues, setmodalFormValues] = useState({});
    const [modalToView, setmodalToView] = useState({})
    const [buttonDisable, setButtonDisable] = useState(false)
    const editHandleClick = (row, type) => {
        let connectionDetails = {};
        let eachRowData = { ...row };
        eachRowData.rockmetric_update = true
        if (type == "edit") {
            if (eachRowData.connection_type === "manual") {
                setmodalFormValues(eachRowData);
                setButtonDisable(true);
            } else {
                connectionDetails = JSON.parse(eachRowData.connection_details);
                eachRowData.connection_details = connectionDetails;
                setmodalFormValues(eachRowData);
                setButtonDisable(false);
            }
            modalConfig['editConnection']["formKey"] = `editConnectionForm_${Math.floor(Math.random() * 10)}`
            setTimeout(() => {
                jQuery("#editContent").modal('toggle');
            }, 5);
        } else if (type == "disable" || type == "delete") {
            let formUpload = JSON.parse(JSON.stringify(formArray["confirmationForm"]));
            let config = JSON.parse(JSON.stringify(modalConfig1["confirmationModal"]));
            if (type == "disable") {
                formUpload['message']['label'] = "Are you sure you want to disable the connection?"
                config['title'] = "Disable Connection"
                config['button_name'] = "Disable"
            } else if (type == "delete") {
                formUpload['message']['label'] = "Are you sure you want to delete the connection?"
                config['title'] = "Delete Connection"
                config['button_name'] = "Delete"
            }
            config['isLoading'] = false;
            config['formKey'] = `confirmationForm_${Math.floor(Math.random() * 10)}`;
            setmodalToView({ modal: config, formUpload: formUpload, row: row });
            setTimeout(() => {
                jQuery("#confirmationModal").modal('toggle');
            }, 5);
        }
    }

    const connectionSetting = (e) => {
        let formData = {}, checkValidity = true;
        $("#editConnection").serializeArray().map(function (innerData) {
            if (checkValidity) {
                if (innerData.name === 'connection_name' || innerData.name === 'databasename') {
                    checkValidity = checkSpecialChars(innerData.value) ? false : true
                } else if (innerData.name === 'dbusername') {
                    checkValidity = /^[a-zA-Z0-9.@]+$/.test(innerData.value) ? true : false
                } else if (innerData.name === 'dbport') {
                    checkValidity = checkSpecialChars(innerData.value, 'number') ? true : false
                }
                checkValidity ? formData[innerData.name] = innerData.value : null
            }
        })
        if (checkValidity === false) {
            alert('Please enter valid inputs!');
            setTimeout(() => {
                jQuery("#editContent").trigger('reset');
            }, 5);
        }
        else {
            modalFormValues.connection_details = JSON.stringify(formData);
            modalFormValues.rockmetric_update = true
            modalFormValues.rockmetric_update_columns = ['connection_details']
            updateRecord([modalFormValues])
            setTimeout(() => {
                jQuery("#editContent").modal('toggle');
            }, 5);
        }
        e.preventDefault();
    }

    const confirmModalSubmission = (e) => {
        let eachRowData = { ...modalToView.row };
        eachRowData.rockmetric_update = true
        eachRowData.isDeleted = 1;
        eachRowData.rockmetric_update_columns = ['isDeleted']
        let sampleModalData = { ...modalToView }
        sampleModalData.modal['isLoading'] = true
        sampleModalData.modal['formKey'] = `confirmationForm_${Math.floor(Math.random() * 10)}`;
        setmodalToView(sampleModalData);
        updateRecord([eachRowData])
        setTimeout(() => {
            jQuery("#confirmationModal").modal('toggle');
        }, 5);
        e.preventDefault();
    }

    let topButton = [{ "name": "Add Connection", "className": 'btn btn-primary btn-sm mg-r-10 text-white', "type": "add", "icon": "plus", "link": "/adminpanel/v2/initialize_connector" }];
    let filterStatus = true;
    let columnData = [
        {
            "virtualName": "Connection Name", "rawField": "connection_name", "edit": "input", "moreOption": [
                { "icon": "far fa-edit", "name": "Edit Settings", "action": "callback", "event": editHandleClick, "type": "edit" },
                // { "icon": "fas fa-ban", "name": "Disable", "action": "callback", "event": editHandleClick, "type": "disable" },
                { "icon": "far fa-trash-alt", "name": "Delete", "action": "callback", "event": editHandleClick, "type": "delete" },
            ]
        },
        { "virtualName": "Connection Type", "rawField": "connection_type", "type": "image", "baseURL": "/assets/connectionType/" },
        { "virtualName": "Last Modified", "rawField": "timestamp", "displayType": "date" },
        { "virtualName": "Succesful", "rawField": "successCount", "centerAlign": true, displayType: "number" },
        { "virtualName": "Failed", "rawField": "failedCount", "centerAlign": true, displayType: "number" },
        // { "virtualName": "Connection Status", "rawField": "summary_connection", "type": "status", "displayType": "both", "jsonKey": { fail: "Fail", success: "Success", failValue: null, successValue: null } },
        { "virtualName": "Author", "rawField": "username", "type": "avtar" }
    ]

    let formVar = {}
    if (modalFormValues.connection_details === "" && modalFormValues.connection_type === "manual") {
        formVar = {
            "message": {
                "name": "message", "label": "Information", "type": "text", "text_value": "Direct File Upload (Manual Upload) does not have Connection Details.", "disabled": true
            }
        }
    } else if (modalFormValues.connection_details) {
        Object.keys(modalFormValues.connection_details).map(function (key) {
            if (key === 'dbpassword') {
                formVar[key] = { name: key, label: key, type: 'password', 'text_value': modalFormValues.connection_details[key], eyeIcon: true }
            } else {
                formVar[key] = { name: key, label: key, type: "text", "text_value": modalFormValues.connection_details[key] }
            }
        })
    }

    const auth_array = Object.keys(modalFormValues).length > 0 ? <Form label_array={formVar} /> : null;
    modalConfig = {
        "editConnection": {
            "id": "editContent", "form_id": "editConnection", "form_name": "editConnection", "title": "Edit Existing Connection", "body": auth_array, "button_name": "Apply", "display": true, "disabledFlag": buttonDisable, buttonType: "submit", "formKey": `editConnectionForm_${Math.floor(Math.random() * 10)}`
        }
    }

    let filterForm = Object.keys(modalToView).length > 0 ? <Form label_array={modalToView.formUpload} /> : null
    Object.keys(modalToView).length > 0 ? modalToView.modal['body'] = filterForm : null;

    return (
        <>
            <DataTableComponent
                tableData={tableData}
                setTableData={setTableData}
                addFilter={filterStatus}
                topButton={topButton}
                columnData={columnData}
                filterColumnName={'connection_name'}
            />
            {auth_array ? <ModalComponent modalConfig={modalConfig["editConnection"]} action={connectionSetting} /> : null}
            {filterForm ? <ModalComponent modalConfig={modalToView.modal} formSubmit={confirmModalSubmission} /> : null}
        </>
    )
}

export default DisplayConnectionTable;
